export const menuData = [
    {title: "Tax Center", link:"/taxcenter"},
    {title: "Newsletters", link:"/newsletter"},
    {title: "Services", link:"/services"},
    {title: "Our Team", link:"/ourteam"},

]